// components/split/ResizeHandle.js
// Divider draggable pour SplitChatView — Session 20

import React, { useState, useCallback, useEffect, useRef } from 'react';

const ResizeHandle = ({ onDrag, containerRef }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    if (!containerRef?.current) return;
    setIsDragging(true);
    startXRef.current = e.clientX;
    startWidthRef.current = containerRef.current.querySelector('[data-chat-pane]')?.offsetWidth || 0;
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  }, [containerRef]);

  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e) => {
      if (!containerRef?.current) return;
      const containerW = containerRef.current.offsetWidth;
      const delta = e.clientX - startXRef.current;
      const newW = startWidthRef.current + delta;
      const pct = (newW / containerW) * 100;
      const clamped = Math.min(Math.max(pct, 25), 75);
      requestAnimationFrame(() => onDrag(clamped));
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    };
  }, [isDragging, containerRef, onDrag]);

  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: '4px',
        cursor: 'col-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        zIndex: 10,
      }}
    >
      {/* Grip indicator */}
      <div style={{
        width: '2px',
        height: '40px',
        borderRadius: '2px',
        background: isDragging
          ? 'var(--accent, #3B82F6)'
          : isHovered
            ? 'rgba(59,130,246,0.6)'
            : 'rgba(255,255,255,0.1)',
        transition: isDragging ? 'none' : 'background 0.2s ease',
        boxShadow: isDragging ? '0 0 8px rgba(59,130,246,0.4)' : 'none',
      }} />
    </div>
  );
};

export default ResizeHandle;
